// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2SmY-","consentsList":"PatientConsents_consentsList__1QyN0","consentsListEmpty":"PatientConsents_consentsListEmpty__28FQB"};